<template>
  <div class="iot">
    <div class="header">
      <div class="title">物联子系统</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list">
        <router-link class="item" v-for="item in iotList" :key="item.id" :to="item.path">
          <img :src="item.logo" alt="" />
          <div>{{ item.title }}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import iot1 from "../../../../assets/product/iot1.png";
import iot2 from "../../../../assets/product/iot2.png";
import iot3 from "../../../../assets/product/iot3.png";
import iot4 from "../../../../assets/product/iot4.png";
import iot5 from "../../../../assets/product/iot5.png";
import iot6 from "../../../../assets/product/iot6.png";
import iot7 from "../../../../assets/product/iot7.png";
import iot8 from "../../../../assets/product/iot8.png";

export default {
  setup() {
    return reactive({
      iotList: [
        {
          id: 1,
          title: "智能门禁",
          logo: iot1,
          path: "/pc/programme/accesscontrol",
        },
        {
          id: 2,
          title: "智能监控",
          logo: iot2,
          path: "/pc/programme/monitor",
        },
        {
          id: 3,
          title: "楼宇对讲",
          logo: iot3,
          path: "/pc/programme/intercom",
        },
        {
          id: 4,
          title: "智能梯控",
          logo: iot4,
          path: "/pc/programme/laddercontrol",
        },
        {
          id: 5,
          title: "智能家居",
          logo: iot5,
          path: "/pc/programme/homefurnishing",
        },
        {
          id: 6,
          title: "智能充电",
          logo: iot6,
          path: "/pc/programme/charge",
        },
        {
          id: 7,
          title: "智能停车",
          logo: iot7,
          path: "/pc/programme/parking",
        },
        {
          id: 8,
          title: "智能能耗",
          logo: iot8,
          // path: "/pc/programme/energyconsumption",
          path: ''
        },
      ],
    });
  },
};
</script>

<style scoped>
.iot {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body .list {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
}
.body .list .item {
  height: 118px;
  position: relative;
}
.body .list .item:hover {
  box-shadow: 8px 8px 8px 1px rgba(31, 81, 210, 0.1);
}
.body .list .item img {
  width: 118px;
}
.body .list .item div {
  position: absolute;
  bottom: 23%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 13px;
  color: #2a3d50;
}
</style>
